export default class MaterialPricingController {
  constructor(ProductsDataProvider, $stateParams) {
    "ngInject";
    let {
      product,
      material
    } = $stateParams;

    this.tpl = `${product}-${material}.html`;
    this.ProductsDataProvider = ProductsDataProvider;
    this.product = ProductsDataProvider.products.findOne({slug: $stateParams.product});
    this.material = this.product.materials
      .find((material) => material.slug == $stateParams.material);
    this.pricing = this.material.pricing;
  }

  uniqueColors(colors) {
    let
      flags = {},
      flags2 = {};
    return colors.filter(function (color) {
      if (flags[color.hex1] && flags[color.hex2]) {
        return false;
      }
      flags[color.hex1] = true;
      flags2[color.hex2] = true;
      return true;
    });
  }

  addColor() {
    if (this.selected == undefined)
      return;
    if (this.material.slug == 'decor-1-color') {
      let
        alreadyHasColor = this.pricing.color.some((color) => (color.value.hex1 == this.selected.hex1) && (color.value.hex2 == this.selected.hex2))
      if (alreadyHasColor) {
        return;
      }
      this.pricing.color.push({
        calcMethod: 0,
        cost: 0,
        startCost: 0,
        value: {hex1: this.selected.hex1, hex2: this.selected.hex2}
      })
    }
    else {
      let
        alreadyHasColor = this.pricing.color.some((color) => color.value == this.selected.hex1)
      if (alreadyHasColor) {
        return;
      }
      this.pricing.color.push({calcMethod: 0, cost: 0, startCost: 0, value: this.selected.hex1})
    }

  }

  removeColor(color, color1) {
    if (color1 != '') {
      let
        index = this.pricing.color.findIndex(function (el) {
          return (el.value.hex1 === color && el.value.hex2 === color1);
        });
      if (index !== -1) {
        this.pricing.color.splice(index, 1);
      }
    }
    else {
      let
        index = this.pricing.color.findIndex(function (el) {
          return (el.value === color);
        });
      if (index !== -1) {
        this.pricing.color.splice(index, 1);
      }
    }

  }

  newSizeCost() {
    let
      tableStand = {
        width: {
          min: 0,
          max: 0
        },
        height: {
          min: 0,
          max: 0
        },
        startCost: 0,
        cost: 0,
        weight: 20,
        calcMethod: 5
      };
    this.pricing.fixMethod['table-stand'].push(tableStand);
  }

  newSizeCostCal() {
    let
      sizes = {
        width: {
          min: 0,
          max: 0
        },
        height: {
          min: 0,
          max: 0
        },
        startCost: 0,
        cost: 0,
        weight: 20,
        calcMethod: 5
      };
    if (this.pricing.fixMethod['sizes'] == undefined)
      this.pricing.fixMethod['sizes'] = [];
    this.pricing.fixMethod['sizes'].push(sizes);
  }

  saveSpec() {
    let
      productSlug = this.product.slug,
      materialSlug = this.material.slug;

    this.ProductsDataProvider
      .saveProductMaterialPricing(productSlug, materialSlug, this.pricing)
  }
}


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/products/components/material-pricing/controller.js
 **/